import React from 'react'
import classNames from 'classnames'
import ImageResolutions from '@toasttab/shared/src/components/atoms/Image/ImageResolutions'
import { FiftyDemoFormProps } from './FiftyDemoForm.d'
import { createCssString } from '@toasttab/shared/src/utils/cssUtils'
import MainFormContentful from '@toasttab/shared/src/components/molecules/Contentful/Form/MainFormContentful'

const FiftyDemoForm = ({
  bgColor,
  children,
  cssClasses,
  imagePosition,
  imageResolutions,
  scrollTrackingSectionName,
  sectionDescription,
  sectionHeading,
  uniqueId,
  dataTestId
}: FiftyDemoFormProps) => {
  const form = children[0]

  let isContentSet = sectionHeading !== '' || sectionDescription !== ''
  let textColorClass
  switch (bgColor) {
    case 'bg-blue-50':
    case 'bg-brand-50':
      textColorClass = 'text-white'
      break
    default:
      textColorClass = 'text-gray-125'
      // isContentSet = sectionHeading !== '' || sectionDescription !== ''
      break
  }

  const rightImage = imagePosition === 'right'
  const sectionClasses = classNames(createCssString(cssClasses), {
    'bg-brand-right': bgColor === 'bg-brand-50' && rightImage,
    'bg-brand-left': bgColor === 'bg-brand-50' && !rightImage
  })
  const contentClasses = classNames(
    'col-span-12 py-10 px-4 -mr-4 -ml-4 md:pt-[6.5rem] md:px-[9.25rem] md:-mx-6 lg:col-span-6 lg:px-0 lg:pb-[7.5rem] lg:pt-20 grid gap-0 items-center',
    bgColor,
    {
      'order-1 lg:order-2 lg:-ml-3': rightImage,
      // Left image position classes
      'order-1 lg:order-2 lg:-mr-3 xl:w-[624px] lg:ml-0': !rightImage,
      'lg:pr-24': !rightImage && isContentSet,
      'lg:pr-0': !rightImage && !isContentSet,
      'items-center': !isContentSet
    }
  )
  const imgClasses = classNames('!rounded-lg max-w-[624px]', {
    'lg:pl-4 lg:-mr-12 w-full': rightImage,
    '2xl:-ml-12 w-full xl:w-[624px]': !rightImage,
    'lg:[&>img]:w-full lg:[&>img]:max-w-none': isContentSet
  })
  const formClasses = classNames(
    'col-span-12 h-100 pt-10 pb-20 md:px-[9.25rem] md:pb-[6.5rem] lg:col-span-6 lg:px-0 lg:pb-[7.5rem] lg:pt-20',
    {
      'lg:pl-9 order-1': rightImage,
      'lg:pl-9 order-1 lg:order-2': !rightImage
    }
  )

  let formObj = form

  const numSteps = formObj.formSteps ? formObj.formSteps.length : 0
  if (numSteps === 1) {
    delete formObj.heading
    formObj.formSteps.forEach((step: any) => {
      delete step.title
      delete step.description
    })
  }

  return (
    <section
      className={sectionClasses}
      id={uniqueId}
      data-tracking-section={scrollTrackingSectionName}
      data-testid={dataTestId}
    >
      <div className='ds-wrapper'>
        <div className='ds-container ds-grid gap-y-0'>
          <div className={contentClasses}>
            <div>
              {imageResolutions && (
                <ImageResolutions
                  images={{ imageResolutions }}
                  classes={imgClasses}
                />
              )}
            </div>
          </div>
          <div className={formClasses}>
            {numSteps === 1 && sectionHeading && (
              <h3 className='mb-4 text-gray-125'>{sectionHeading}</h3>
            )}
            {numSteps === 1 && sectionDescription && (
              <p className='mb-4 text-gray-100'>{sectionDescription}</p>
            )}
            <MainFormContentful
              {...formObj}
              componentContext='ContentfulMdsShowcaseForm'
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default FiftyDemoForm
